import { NgModule } from '@angular/core'
import { CmsComponentsBaseModule } from '../cms/components/cms-components-base.module'
import { PaginationModule } from '@spartacus/storefront'
import { MbI18nModule } from '../translations/mb-i18n.module'
import { ReactiveFormsModule } from '@angular/forms'
import { MbTranslatePipe } from '../translations/mbTranslate.pipe'
import { UserAccountService } from '@spartacus/user/account/core'
import { MpupInventoryModule } from './mpup-inventory/mpup-inventory.module'
import { MpupSharedModule } from './mpup-shared/mpup-shared.module'
import { MpupTransactionsModule } from './mpup-transactions/mpup-transactions.module'
import { ConfigModule } from '@spartacus/core'

@NgModule({
  declarations: [],
  imports: [
    CmsComponentsBaseModule,
    MbI18nModule,
    ReactiveFormsModule,
    PaginationModule,
    MpupInventoryModule,
    MpupSharedModule,
    MpupTransactionsModule,
    ConfigModule.withConfig({
      pagination: {
        addDots: true,
        rangeCount: 5,
        addLast: true,
        addFirst: true,
        substituteDotsForSingularPage: true,
      }
    })
  ],
  providers: [
    MbTranslatePipe,
    UserAccountService
  ]
})
export class MpupModule {
}
